import * as yup from 'yup';

export const PartnerSchema = yup.object({
  id: yup.number().defined(),
  name: yup.string().defined(),
  created_at: yup.string().nullable(),
  revoked_at: yup.string().nullable(),
});
export type Partner = yup.InferType<typeof PartnerSchema>;

export const PartnersListSchema = yup
  .array()
  .of(PartnerSchema.defined())
  .defined();
export type PartnersList = yup.InferType<typeof PartnersListSchema>;
